<template>
  <div id="OpenAccountApply">
    <van-action-sheet v-model:show="showVerify" title="短信验证" class="showVerify">
      <div class="tip">已发送至 {{ borrowerPhone }}</div>
      <div class="input-box">
        <input type="text" class="messageCode" placeholder="请输入短信验证码" v-model="messageCode" maxlength="6" @input="messageCode = messageCode.replace(/[^0-9]/g, '')">
        <a 
          class="send" 
          :disabled="countdown > 0" 
          @click="sendCode"
        >
          {{ countdown > 0 ? `${countdown}s后重试` : '重新发送' }}
        </a>
      </div>
      <div class="box-btn">
        <Button type="danger" text="提交" class="nextStep" :click="submitCode"/>
      </div>
    </van-action-sheet>
    <van-cell-group class="mt8 forms">
      <Input class="temr" placeholder="请输入姓名" v-model="borrowerName" :readonly="true" labelWidth="110px"
        :reg="rules.borrowerName" label="持卡人姓名" />
        <SelfSelect
          label="银行名称"
          placeholder="请选择银行名称"
          v-model="bankCode"
          :columnsTerm="banklist"
          :defaultValue="bankCode"
        />
      <Input class="temr" placeholder="请输入银行卡号" v-model="bankCardNo" maxlength="30" labelWidth="110px" type="tel"
        :reg="rules.bankCardNo" label="银行卡号" />
      <Input class="temr" placeholder="请输入银行预留手机号" v-model="borrowerPhone" maxlength="11" labelWidth="110px" border
        type="tel" :reg="rules.borrowerPhone" label="银行预留手机号" />
    </van-cell-group>
    <ContractFold text="本人已阅读并完全同意" :api="contractApi" :defaultCheck="false" v-model="agreeState" />
    <div class="fix-btm">
      <Button :text="draw" :type="danger" :disabled="canGoNext" class="nextStep" :click="goToNextPage" />
    </div>
  </div>
</template>
<script>
import ContractFold from '@/components/ContractFold.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import Loading from '@/components/Loading.vue';
import { Toast, Dialog } from 'vant';
import { rules } from '@/utils';
import MessageCode from './components/MessageCode.vue';
import BWSelect from './components/BWSelect.vue';

export default {
  name: 'bankCardBinding',
  data() {
    return {
      danger: 'danger',
      draw: '提交',
      contractApi: '/backloansuper/loan/supermarket/contract/list?stage=BIND_CARD',
      agreeState: false,
      banklist: [],
      showVerify: false,
      ShowPopupContent: '',
      ShowGiveUpContent: '',
      loadingBox: false,
      timerInteval: '',
      bankCardNo: '',
      borrowerPhone: '',
      borrowerName: '',
      bankCode: '',
      rules,
      messageCode: '',
      countdown: 0,
      smsSerialNo:'',
    };
  },
  components: {
    Button,
    BWSelect,
    Input,
    MessageCode,
    Loading,
    ContractFold,
  },
  mounted() {
    const {
      querySupportBanks,
      queryBankCard,
    } = this.$api.CommonForms;
    const { orderId } = this.$router.currentRoute.query;
    querySupportBanks({partnerCreditNo: orderId}).then((res) => {
      if (res && res.data && res.data.result === 'S') {
        this.banklist = res.data.supportBankList.map((item) => ({
          text: item.name,
          value: item.code,
        }));
        queryBankCard({partnerCreditNo: orderId}).then((res) => {
          if (res && res.success) {
            const { borrowerName, borrowerPhone, classOneCard, bankCode } = res.data
            this.borrowerName = borrowerName||'';
            this.borrowerPhone = borrowerPhone||'';
            this.bankCardNo = classOneCard||'';
            this.bankCode = bankCode||'';
          } else {
            Toast(res.returnMessage);
          }
        });
      } else {
        Toast(res.returnMessage);
      }
    });
    
  },
  computed: {
    canGoNext() {
      const temrData = ['bankCode'];
      let multiCheck = false;
      temrData.forEach((item) => {
        console.log(this.$store.state.commonForms[item]);
        if (this.$store.state.commonForms[item] === '') {
          multiCheck = true;
        }
      });
      const regOne = /^1\d{10}$/;
      const regtwo = /^\d{8,30}$/;
      if (
        !regOne.test(this.borrowerPhone)
        || !regtwo.test(this.bankCardNo)
      ) {
        multiCheck = true;
      }
      if (!this.agreeState) {
        multiCheck = true;
      }
      return multiCheck;
    },
  },
  watch: {
  },
  methods: {
    getBankName(code) {
      const bank = this.banklist.find((item) => item.value === code);
      return bank ? bank.text : '';
    },
    goToNextPage() {
      this.loadingBox = true;

      const { scene= 'LOAN', orderId, productId, drawId = null } = this.$router.currentRoute.query;
      this.$api.CommonForms.checkBindCard({
        scene,
        productId,
        partnerCreditNo: orderId,
        bankCardNo: this.bankCardNo,
        phoneNo: this.borrowerPhone,
        partnerLoanNo: drawId,
        name: this.borrowerName,
        bankCode: this.bankCode,
        bankName: this.getBankName(this.bankCode)
      }).then((res) => {
        if (res.success) {
          this.loadingBox = false;
          if(res.data.status === 'WAIT_VERIFY'){
            this.showVerify = true;
            this.startCountdown();
            this.smsSerialNo = res.data.smsSerialNo;
          }else if(res.data.status === 'FAILED'){
            Toast(res.data.reasonMsg);
          }else{
            window.location.href = res.data.url;
          }
        } else {
          this.loadingBox = false;
          Toast(res.returnMessage||res.message);
        }
      });
    },
    startCountdown() {
      this.countdown = 60;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    sendCode() {
      this.goToNextPage()
    },
    submitCode() {
      const { scene= 'LOAN', orderId, productId, drawId = null } = this.$router.currentRoute.query;
      this.$api.CommonForms.verifyBindCard({
        scene,
        productId,
        partnerCreditNo: orderId,
        bankCardNo: this.bankCardNo,
        phoneNo: this.borrowerPhone,
        partnerLoanNo: drawId,
        name: this.borrowerName,
        smsSerialNo: this.smsSerialNo,
        verifyCode: this.messageCode,
        bankCode: this.bankCode,
        bankName: this.getBankName(this.bankCode)
      }).then((res) => {
        if (res.success) {
          if(res.data.status ==='S'){
            window.location.href = res.data.url;
          }else{
            Toast(res.data.reasonMsg);
          }
        }else{
          Toast(res.returnMessage||res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
.forms {
  margin-bottom: 16px;
  background: #FFFFFF;
}

>>>.van-field__label {
  width: 110px;
}

.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}

.mt8 {
  padding-top: 8px;
}



.getCode {
  color: rgba(246, 82, 73, 1);
  font-weight: 400;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}

.code_btn {
  position: absolute;
  right: 14px;
  bottom: 7px;
  z-index: 3;
  width: auto;
  height: 35px;
  background: #fff;
  border: none;
}

.loadingBox {
  position: fixed;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
}

.close {
  width: 100%;
  height: 40px;
  line-height: 40px;
  position: relative;
  border-bottom: 1px solid #e9f0f5;
  font-family: PingFangSC-Regular;
  font-size: 17px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
}

>>>.van-field__control::placeholder {
  color: #767676 !important;
}

>>>.van-field__label {
  color: #1c2438;
}

>>>.van-field__control {
  margin-left: -11px;
}
.box-btn{
  padding: 8px 0;
}
.tip{
  font-size: 14px;
  color: #7A7A7A;
  font-weight: 400;
  margin-bottom: 16px;
}
.fix-btm {
  width: 100%;
  padding: 8px 0;
  background: #FFFFFF;
  position: fixed;
  bottom: 0;
}
.input-box{
  width: 100%;
  height: 40px;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
  .send{
    font-size: 14px;
    color: #FF6538;
    text-align: center;
    position: absolute;
    right: 32px;
    top: 9px;
    font-weight: 400;
  }
  .messageCode{
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid rgba(224,224,224,1);
    border-radius: 3px;
    font-size: 16px;
    color: #1c2438;
    padding: 8px 16px;
    font-weight: 400;
  }
}
</style>
